.buttonForm {
	font-size: 0.7em !important;
	font-weight: bold !important;
	border-radius: 10px !important;
}

.selecttags {
	border-radius: 10px;
	min-height: 5em;
	box-sizing: border-box;
	padding: 10px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-around;
	margin-top: 1em;
	cursor: pointer;
	background-color: #85bf46;
	transition: 0.5s;

	.icon {
		width: 3em;
		height: 3em;
		fill: white;
	}

	.title {
		color: white;
		font-size: 15px;
		font-weight: bold;
	}

	&.active {
		background-color: #fafafa;
		transition: 0.5s;

		.icon {
			fill: #85bf46;
		}

		.title {
			color: #85bf46;
		}
	}
}

.tableSimple {
	width: 100%;
	background-color: #f6f6f6;
	font-size: 13px;
	border-radius: 5px !important;

	thead {
		padding: 0 3rem;
		font-size: 14px;

		th {
			padding: 0.5em 1em;
			text-align: center;
		}
	}

	tbody {
		padding: 0 3rem;

		tr td {
			height: 2.5rem;
			border-top: 1px solid #dcdcdd;
			text-align: center;
		}

		input {
			width: 50%;
			display: block;
			margin-right: auto;
			margin-left: auto;
			height: 2em;
			border-radius: 10px;
			text-align: right;
		}
	}
}

.scrollDivTable {
	max-height: 300px;
	overflow-y: scroll;

	&::-webkit-scrollbar {
		width: 5px;
		height: 5px;
	}

	&::-webkit-scrollbar-track {
		background: #f1f1f1;
	}

	&::-webkit-scrollbar-thumb {
		background-color: #a8a8a8;
		border-radius: 15px;
	}
}
